import i18n from 'i18n';
import Spinner, {SpinnerSize} from '@/components/ui/Spinner';

interface CellLoaderProps {
    text?: string;
    fullHeight?: boolean;
    size?: SpinnerSize;
}

const CellLoader = ({text=i18n.t('jt_loading_data_general.text'), fullHeight = true, size = 'sm' as SpinnerSize}:CellLoaderProps) => (
    <div 
        className={`text-center d-flex flex-column align-items-center ${fullHeight ? 'justify-content-start pt-5' : 'justify-content-center'}`}
        id='spinner-loader'
        style={fullHeight ? {minHeight: '100vh'} : {}}
    >
        <Spinner size={size} text={text} centered/>
    </div>
);

export default CellLoader;